import { Link, Box, Card, Grid, styled, Typography, Avatar } from '@mui/material';

import { useTranslation } from 'react-i18next';
import Text from 'src/components/Text';
import AccessTimeTwoToneIcon from '@mui/icons-material/AccessTimeTwoTone';
import React, { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { Client, MessageDto } from '../../../core/DashboardApi/api';
import { REACT_APP_PORTAL_API_URL } from '../../../KeyVariables';
import { formatDistance, parse } from 'date-fns';
import { ro } from 'date-fns/locale';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const DividerVertialPrimary = styled(Box)(
  ({ theme, bgColor }) => `
    height: 60%;
    width: 6px;
    left: -3px;
    border-radius: 50px;
    position: absolute;
    top: 20%;
    background: ${bgColor};
  `
);


function TasksWidget() {
  const { t }: { t: any } = useTranslation();
  const theme = useTheme();
  const taskClient = new Client(REACT_APP_PORTAL_API_URL);
  const [tasks, setTasks] = useState<MessageDto[]>([]);
  const iconMap = {
    New: <AddIcon/>,
    InProgress: <MoreHorizIcon/>,
    Done: <DoneIcon/>,
  };
  
  
  const colorsMap = {
    New: theme.colors.info.main,
    InProgress: theme.colors.warning.main,
    Done: theme.colors.success.main,
  };
  useEffect(() => {
    taskClient.gettasks(1, 3).then(data => {
      setTasks(data)
    })
  }, [])

  return (
    <Grid container>
        {
          tasks.length > 0 ?

          tasks.map((notif, i) => (
            <Grid item xs={12} md={12} pt={i > 0 ? 1 : 0}>
            <Card
              sx={{
                overflow: 'visible',
                position: 'relative',
                p: 1.5
              }}
              variant="outlined"
            >
              <DividerVertialPrimary bgcolor={colorsMap[notif.type!]}/>
              <Box sx={{display:"flex",justifyContent:"space-between"}}>
              
              <Box>
              <Typography
                color="text.primary"
                component="a"
                variant="h4"
                fontWeight="bold"
              >
               {notif.subject}: 
              </Typography>
              <Typography
                color="text.primary"
                component="a"
                variant="h4"
                fontWeight="normal"
              >
               {' ' + notif.body} 
              </Typography>
              </Box>
              
              <Typography
                variant="h4"
              >
                {notif.component}
              </Typography>
              </Box>
              <Box mt={1.5} display="flex" alignItems="center">
              <Avatar
                sx={{
                  width: 30,
                  height: 30,
                  background: colorsMap[notif.type!]
                }}
              >
                {React.cloneElement(iconMap[notif.type!], {
                  fontSize: 'small' 
                })}
              </Avatar>
                <Text flex >
                  <AccessTimeTwoToneIcon
                    sx={{
                      ml: 1,
                      mr: 0.5
                    }}
                    fontSize="small"
                  />
                  Deadline: {formatDistance(parse(notif.dateTime!, 'HH:mm dd.MM.yyyy', new Date()), new Date(), {
                            addSuffix: true,
                            locale:ro,
                          })}
                </Text>
              </Box>
            </Card>
          </Grid>
          )) : null
        }
    </Grid>
  );
}

export default TasksWidget;
